interface DateRatesInput {
  [date: string]: number;
}

interface DateRatesReturn {
  [date: string]: number;
}

export function toBestDateRates(
  dateRates: DateRatesInput,
  betterDateRates?: DateRatesInput,
  currencyCode?: string | null
) {
  if (!currencyCode) {
    return;
  }
  const bestDateRates: DateRatesReturn = {};
  for (const date in dateRates) {
    if (Object.prototype.hasOwnProperty.call(dateRates, date)) {
      const price = dateRates[date];
      bestDateRates[date] = price;
    }
  }
  for (const date in betterDateRates) {
    if (Object.prototype.hasOwnProperty.call(betterDateRates, date)) {
      const price = betterDateRates[date];
      bestDateRates[date] = price;
    }
  }
  return bestDateRates;
}
